import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/generador/components/GeneradorContent.tsx");
